module.exports = __webpack_public_path__ + "img/GreekTechBalista1_ua.a259493f.webp";